import { getLocalizedString } from '../../utils/i18n-utils';
import MutedText from '../common/MutedText';

export default function SmsSentInfo({ formattedPhoneNumber }: { formattedPhoneNumber: string }) {
  return (
    <div className="fe_u_text-align--center fe_u_margin--bottom-medium">
      <MutedText className="sms-sent-instruction-item" text={getLocalizedString('oie.enroll.okta_verify.sms.info.beginning')} />
      <p className="fe_u_font-weight--bold sms-sent-instruction-item">{formattedPhoneNumber}</p>
      <MutedText
        className="sms-sent-instruction-item"
        text={getLocalizedString('oie.enroll.okta_verify.sms.info.end')}
      />
    </div>
  );
}
